// Rafiki's own ads: two separate switches, so the apps can carry ads while the website stays
// ad-free (or the other way round).
//
//   APP_ADS_ENABLED          AdMob in the iPhone/Android apps (Capacitor): the interstitial
//                            between games in nativeAds.ts (and the banner, if SHOW_BANNER is
//                            ever turned on there). Never touches the website or the portals.
//   WEBSITE_ADSENSE_ENABLED  Google AdSense on playrafiki.com: the AdSense loader script
//                            (adsense.ts) and the banner units in MobileAdvertisement /
//                            DesktopAdvertisement. Never touches the apps or the portals.
//
// Both are off while the player base is being built up: ads slow the first load and at today's
// traffic they earn pennies.
//
// Other ad switches, unchanged and independent of these two:
//   REWARDED_ENABLED (rewardedAd.ts)    the optional rewarded ad (Daily Rafiki extra peek), apps
//                                       only. It starts AdMob through the shared ensureAdMob() in
//                                       nativeAds.ts, which is not behind APP_ADS_ENABLED, so the
//                                       rewarded ad can be switched on with or without interstitials.
//   REMOVE_ADS_ENABLED (removeAds.ts)   the "Remove ads" purchase in the apps.
//
// Portals (Playgama, which also makes the Yandex build, GameDistribution, CrazyGames) and the
// Discord build never show AdSense or AdMob, whatever these flags say: they use only their own
// SDK's ads (revenue share on their side).
//
// Flags are constants: switching one means editing it and rebuilding (and, for the apps,
// rebuilding the app's web copy and the app).
export const APP_ADS_ENABLED = false;
export const WEBSITE_ADSENSE_ENABLED = false;

// Tests only: the flags are constants, so the tests switch them here (undefined = use the constant).
let appForTests: boolean | undefined;
let websiteForTests: boolean | undefined;
export const _setAdFlagsForTests = (flags?: { app?: boolean; website?: boolean }) => {
  appForTests = flags?.app;
  websiteForTests = flags?.website;
};

export const appAdsEnabled = (): boolean => (appForTests === undefined ? APP_ADS_ENABLED : appForTests);
export const websiteAdSenseEnabled = (): boolean =>
  websiteForTests === undefined ? WEBSITE_ADSENSE_ENABLED : websiteForTests;
